import './App.css';
import React from 'react';

const SHEET_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vT9kwvrjpuBTc3VmGm8mPpyt68LMfbL3-20xccU_0OQQeSqvbpelWGvb1rsqfVuCgLsaVJs5whgSRKm/pub?gid=2114182751&single=true&output=csv";
const IMAGE_BASE_URL = "https://tok-p.com/img/cut/";

function App() {
  const [selectedBreed, setSelectedBreed] = React.useState('すべて');
  const [zoomImg, setZoomImg] = React.useState(null); // ズーム用
  const [images, setImages] = React.useState([]);

  React.useEffect(() => {
    fetch(SHEET_URL)
      .then(res => res.text())
      .then(text => {
        // カンマ区切りで分割
        const rows = text.trim().split('\n').map(row => row.split(','));
        // 1行目はヘッダー（画像,犬種）なので除外
        const data = rows.slice(1).map(([file, breed]) => ({
          file: file.trim(),
          breed: breed.trim()
        }));
        setImages(data);
      });
  }, []);

  const filtered = selectedBreed === 'すべて' ? images : images.filter(img => img.breed === selectedBreed);

  return (
    <div className="cut-gallery-root">
      <div className="filter-bar">
        <select value={selectedBreed} onChange={e => setSelectedBreed(e.target.value)} className="filter-select">
          <option value="すべて">すべて</option>
          {Array.from(new Set(images.map(img => img.breed))).map(breed => (
            <option key={breed} value={breed}>{breed}</option>
          ))}
        </select>
      </div>
      <div className="gallery-grid">
        {filtered.map((img, idx) => (
          <div className="gallery-tile" key={img.file}>
            <div className="tile-no">NO:{String(images.indexOf(img)+1).padStart(2,'0')}</div>
            <img src={IMAGE_BASE_URL + img.file} alt={img.breed} className="tile-img" onClick={()=>setZoomImg(img)} style={{cursor:'zoom-in'}} />
            <button className="reserve-btn" onClick={()=>{
              const no = String(images.indexOf(img)+1).padStart(2,'0');
              window.open(`/assets/calendar_line_g/?img=${img.file}&no=${no}`, '_blank');
            }}>このカットで予約する</button>
          </div>
        ))}
      </div>
      {zoomImg && (
        <div className="zoom-modal" onClick={()=>setZoomImg(null)}>
          <img src={IMAGE_BASE_URL + zoomImg.file} alt={zoomImg.breed} className="zoom-img" />
        </div>
      )}
    </div>
  );
}

export default App;
